'use client'

import {observer} from 'mobx-react'

import * as UIDetail from '@/src/entities/news/ui/detail.styled'

import {ArticleDetailContent} from '@/src/features/news-articles'

import noPhotoPic from '@/src/shared/assets/media/no-photo.png'
import {useStore} from '@/src/shared/hooks/useStore'
import {Image} from '@/src/shared/ui/image'
import {PageData} from '@/src/core/domain/entities/page/page-data'
import React from 'react'

export const ArticleContent = observer(
  (
    props: PageData<ArticleDetailContent> & {
      suspense: {content: React.ReactNode}
    },
  ) => {
    const {pageData} = useStore<ArticleDetailContent>()
    const content = pageData!.content

    return (
      <UIDetail.Article>
        <UIDetail.H1>{content.article.title}</UIDetail.H1>
        {content.article?.cover && content.article.cover.src && (
          <UIDetail.Image>
            <Image
              src={
                (content.article.cover.type === 'image' && `${content.article.cover.src}`) ||
                noPhotoPic
              }
              alt={content.article.title}
              width={603}
              height={401}
            />
          </UIDetail.Image>
        )}

        {props.suspense.content && <UIDetail.Content>{props.suspense.content}</UIDetail.Content>}
      </UIDetail.Article>
    )
  },
)
